import AuthModal from './AuthModal';
import EmailModal from './EmailModal/EmailModal';
import WalletListModal from './WalletListModal/WalletListModal';
import GoogleLoginWideButton from './WideButtons/GoogleLoginWideButton';
import EmailLoginWideButton from './WideButtons/EmailLoginWideButton';
import WalletLoginWideButton from './WideButtons/WalletLoginWideButton';
import OAuth2LoginWideButton from './WideButtons/OAuth2LoginWideButton';
import ButtonGroup from './ButtonGroup';

type ClassesProps = {
  modal?: string;
  container?: string;
};

interface Props {
  classes?: ClassesProps;
  open: boolean;
  onClose?: () => void;
  closable?: boolean;
  logins?: string[];
}

export default function StandardAuthModal({
  classes = {},
  open,
  onClose = () => {},
  closable = true,
  logins = [],
}: Props) {
  const hasGoogleLogin = logins.length === 0 || logins.includes('google');
  const hasEmailLogin = logins.length === 0 || logins.includes('email');
  const hasWalletLogin = logins.includes('wallet');
  const additionalLogins = logins.filter((login) => !['google', 'email', 'wallet'].includes(login));
  return (
    <AuthModal
      modalClassName={classes.modal}
      className={classes.container}
      open={open}
      onClose={onClose}
      closable={closable}
    >
      <ButtonGroup type="wide">
        {hasGoogleLogin && <GoogleLoginWideButton />}
        {hasEmailLogin && <EmailLoginWideButton />}
        {hasWalletLogin && <WalletLoginWideButton />}
        {additionalLogins.map((slug) => <OAuth2LoginWideButton key={slug} slug={slug} />)}
      </ButtonGroup>
      <WalletListModal />
      <EmailModal defaultForm="register" />
    </AuthModal>
  );
}
